import clearFeedback from './clearFeedback';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { FeedbackViewState } from '../store/schema/FeedbackViewState';
import { action, select } from 'satcheljs/lib/legacy';
import { lazyAppendDiagnosticReportToMessage } from 'owa-diagnostic-report';
import { lazySendAutomatedMessage, MessageDetails, AttachmentDetails } from 'owa-automated-message';
import { store } from '../store/store';

export interface SendFeedbackMessageState {
    feedbackStore: FeedbackViewState;
}

const newLineRegex = /(?:\r\n|\r|\n)/g;
const newLineHtml = '<br />';

export default select<SendFeedbackMessageState>({
    feedbackStore: () => store,
})(
    action('sendFeedbackMessage')(async function sendFeedbackMessage(
        state?: SendFeedbackMessageState
    ) {
        // Fill in any default options
        let {
            subject,
            message,
            classification,
            screenshotBlob,
            subjectArea,
            emailAddresses,
        } = state.feedbackStore;

        if (subject) {
            if (message) {
                // replace raw newline characters with break tags
                message = message.replace(newLineRegex, newLineHtml);
            }

            message = (await lazyAppendDiagnosticReportToMessage.import())(message);

            let attachments = screenshotBlob
                ? [
                      {
                          kind: 'File',
                          content: screenshotBlob,
                          name: 'Screenshot.jpg',
                      } as AttachmentDetails,
                  ]
                : null;

            let finalSubject = `OWA Feedback - ${subjectArea} - ${classification} ${subject}`;

            let messageDetails = {
                subject: finalSubject,
                message: message,
                to: emailAddresses,
                attachments: attachments,
            } as MessageDetails;

            let timeFormat = getUserConfiguration().UserOptions.TimeFormat;
            let sendAutomatedMessage = await lazySendAutomatedMessage.import();
            await sendAutomatedMessage(messageDetails, timeFormat);
        }

        clearFeedback(state.feedbackStore);
    })
);
